// removed by extract-text-webpack-plugin
module.exports = {"introLeft":"_1PKP","subtext":"_2V7h","intro-heading":"_1efF","benefits-heading":"_2Wqs","ribbon":"_gLhv","intro-list":"_YbaH","payment-step-info":"_2VxQ","payment-heading":"_2Sds","payment-para":"_xcbK","step-row":"_2jo_","step-wrap":"_2U15","arrow-icon":"_3n3l","btm-info":"_LD2y","introRight":"_1Nk0","cta-wrap":"_2rNb","cta-btn":"_1G7U","cta-btn2":"_2R6X"};


//////////////////
// WEBPACK FOOTER
// ./checkout/components/introduction/style.css
// module id = 0M3z
// module chunks = 4